export const RECEIVE_IMPORT_CATEGORY = 'RECEIVE_IMPORT_CATEGORY';
export const RECEIVE_IMPORT_PRODUCT = 'RECEIVE_IMPORT_PRODUCT';
export const PRE_IMPORT_CATEGORY = 'PRE_IMPORT_CATEGORY';
export const PRE_IMPORT_PRODUCT = 'PRE_IMPORT_PRODUCT';
export const DISABLE_IMPORT = 'DISABLE_IMPORT';
export const ACTIVE_IMPORT = 'ACTIVE_IMPORT';
